import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { NotificationSettingModel } from 'app/models/notification-setting.model';
import { NotificationsService } from 'app/services/notifications.service';
import { Observable } from 'rxjs';

@Injectable()
export class NotificationsResolver  {

    constructor(private notifications_service: NotificationsService)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<NotificationSettingModel> {
        return this.notifications_service.GetNotifications();
  }
}
